<abi-spinner *ngIf="!loaded || !isInited"></abi-spinner>

<form *ngIf="loaded && isInited" role="form" (submit)="saveChanges()" [formGroup]="form">
    <div class="card mb-3">
        <div class="card-header">
            <h5 class="mb-0" translate="Job.Feedback"></h5>
        </div>
        <div class="card-body">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-6" *ngIf="!submitted;else thanks">
                    <div *ngIf="job">
                        <h4>{{ job?.jobId }} -
                            <span [abiLookupdisplay]="model?.categories?.[0]" listName="CodeMachineCategory"></span>
                        </h4>
                        <h5><span [abiLookupdisplay]="job?.typeId" listName="CodeJobType"></span> {{ job?.booked | date }}</h5>
                    </div>

                    <div>
                        <dl class="row">
                            <dt class="col-sm-4" translate="Job.Contact"></dt>
                            <dd class="col-sm-8">{{ job?.contact | contact }}</dd>

                            <dt class="col-sm-4" translate="Job.Resource"></dt>
                            <dd class="col-sm-8">{{ resource?.contact | contact }}</dd>

                            <dt class="col-sm-4" translate="Job.FaultCodeID"></dt>
                            <dd class="col-sm-8" [abiLookupdisplayValue]="job?.faultCodeId" listName="CodeJobFault"></dd>

                            <dt class="col-sm-4" translate="Job.Completed"></dt>
                            <dd class="col-sm-8">{{ job?.completed | date }}</dd>
                        </dl>
                        <div *ngIf="showField('score')" class="row justify-content-center">
                            <abi-form-field
                                [label]="'JobFeedback.ScoreDescription' | translate"
                                cols="col-12"
                                [wrap]="true"
                                [horizontal]="false">
                                <div class="d-flex justify-content-center">
                                    <div ngbRadioGroup class="btn-group btn-group-toggle" formControlName="score" name="score">
                                        <label ngbButtonLabel *ngFor="let score of scores; let index = index" class="btn btn-lg" [ngClass]="score[0]"
                                            [title]="index + 1">
                                            <input ngbButton type="radio" [value]="'' + (index + 1)">
                                            <i class="fa-2x mt-2" [ngClass]="score[1]"></i>
                                        </label>
                                    </div>
                                </div>
                            </abi-form-field>
                        </div>
                        <div *ngIf="showField('resourceScore', false)" class="row">
                            <abi-form-field
                            [label]="'JobFeedback.ResourceScoreDescription' | translate | substitute : {resource: fullName(resource?.contact)}"
                            cols="col-12"
                            [wrap]="true"
                            [horizontal]="false">
                                <div class="d-flex justify-content-center">
                                    <div ngbRadioGroup class="btn-group btn-group-toggle" formControlName="resourceScore" name="resourceScore">
                                        <label ngbButtonLabel *ngFor="let score of scores; let index = index" class="btn btn-lg" [ngClass]="score[0]"
                                            [title]="index + 1">
                                            <input ngbButton type="radio" [value]="'' + (index + 1)">
                                            <i class="fa-2x mt-2" [ngClass]="score[1]"></i>
                                        </label>
                                    </div>
                                </div>
                            </abi-form-field>
                        </div>

                        <div *ngIf="showField('confirmed')" ngbRadioGroup class="btn-group-toggle mt-2 mb-3" formControlName="confirmed" name="confirmed">
                            <label ngbButtonLabel *ngFor="let confirm of confirms; let index = index" class="btn-lg btn-block text-wrap" [ngClass]="confirm[0]">
                                <input ngbButton type="radio" [value]="confirm[2]">
                                <i [class]="confirm[1]"></i> {{ label(index) }}
                            </label>
                        </div>

                        <button *ngIf="!disabled && loaded" type="submit" class="btn btn-primary float-right" [disabled]="form.invalid || !check"
                            translate="System.Submit"></button>
                    </div>

                </div>
                <ng-template #thanks>
                    <h4 class="text-center mb-4">{{ message }}</h4>
                </ng-template>
            </div>
        </div>
    </div>
</form>

<ng-template #saveDialog let-ref="dialogRef">
    <h4 mat-dialog-title>{{ job | job:'cleanJobId' }}</h4>
    <mat-dialog-content>
        {{ confirmationText() }}
    </mat-dialog-content>
    <mat-dialog-actions>
        <button cdkFocusInitial type="button" mat-button (click)="ref.close()" translate="System.Ok"></button>
    </mat-dialog-actions>
</ng-template>
